import moment from "moment";
import { isNullOrEmpty, isNumeric } from "./ObjectHelpers";

function getStringUrlParam(param) {
    const queryParameters = new URLSearchParams(window.location.search);
    return queryParameters.get(param);
}

function getNumericUrlParam(param) {
    return Number(getStringUrlParam(param));
}

function cleanUrl(url) {
    return url.replace('&amp;', '&');
}

function getNumericSearchParam(searchParams, param, defaultValue = 0) {
    const val = searchParams.get(param);
    if (!isNumeric(val)) return defaultValue;
    return Number(val);
}

function getSearchParam(searchParams, param, defaultValue = null) {
    const val = searchParams.get(param);
    if (isNullOrEmpty(val)) return defaultValue;
    return val;
}

function getBooleanSearchParam(searchParams, param) {
    const val = searchParams.get(param);

    if (isNullOrEmpty(val)) return false;
    return val.toLowerCase() === "true" ? true : false;
}

export function getDateSearchParam(searchParams, param, defaultValue = null) {
    const val = searchParams.get(param);
    if (isNullOrEmpty(val)) return defaultValue;
    return moment(val).toDate();
}

/**
 * Encodes a given string into a URL-safe Base64 format.
 *
 * @param {string} str - The string to be encoded.
 * @returns {string} The URL-safe Base64 encoded string.
 */
function base64EncodeURLSafe(str) {
    if (typeof str !== 'string') return null;
    const base64 = btoa(str);
    const uri = encodeURIComponent(base64);
    return uri;
}

/**
 * Decodes a given URL-safe Base64 encoded string.
 *
 * @param {string} str - The URL-safe Base64 encoded string.
 * @returns {string} The decoded string.
 */
function base64DecodeURLSafe(str) {
    if (typeof str !== 'string') return null;
    const uri = decodeURIComponent(str)
    const string = atob(uri);
    return string;
}


export {
    getStringUrlParam,
    getNumericUrlParam,
    cleanUrl,
    getSearchParam,
    getBooleanSearchParam,
    getNumericSearchParam,
    base64EncodeURLSafe,
    base64DecodeURLSafe
}
